import logo2018 from "../../assets/img/historicEvents/LogoEvolution/2018.png";
import logo2025 from "../../assets/img/historicEvents/LogoEvolution/2025.png";

export const evolutionDetail = {
  evolution: {
    id: "evolution",
    title: "Evolution",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "evolution",
        items: [
          {
            id: "evolution-2018",
            title: "Evolution",
            description: "WWE's First-Ever All-Women's Event 2018",
            imgUrl: logo2018,
          },
          {
            id: "evolution-2025",
            title: "Evolution",
            description: "2025",
            imgUrl: logo2025,
          },
        ],
      },
    ],
  },
};
